import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { MyErrorStateMatcher, ValidatorConfig } from '../../../../../../common/field-validation/my-error-state-matcher';
import { UiValidator } from '../../../../../../common/field-validation/ui-validator.dto';

@Component({
  selector: 'app-form-field-code',
  templateUrl: './code-form-field.component.html',
  styleUrls: ['./code-form-field.component.scss'],
  standalone: false,
})
export class CodeFormFieldComponent extends DataTypeComponent implements OnDestroy, OnInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  matcher = new MyErrorStateMatcher();

  modelData: any;

  ngOnDestroy() {}

  condition(v: UiValidator) {
    const formControl = this.getFormControl();
    return this.getValidatorConfig(v).condition(formControl);
  }

  message(v: UiValidator) {
    return this.getValidatorConfig(v).message(v);
  }

  private getValidatorConfig(v: UiValidator): ValidatorConfig {
    return MyErrorStateMatcher.messageMap[v.type];
  }

  private getFormControl(): AbstractControl {
    return this.formGroup.get(this.fieldConfig.name);
  }

  ngOnInit(): void {
    this.modelData = this.data;
    this.formGroup.get(this.fieldConfig.name).setValue(this.modelData);
  }

  onModelChange() {
    if (this.formGroup && this.modelData) {
      // this.formGroup.get(this.fieldConfig.name).setValue(this.modelDate.format(this.dateFormat));
      this.formGroup.get(this.fieldConfig.name).setValue(this.modelData);
    }
  }
}
